import './App.css';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from './pages/Home/Home';
import Event from "./pages/Event/Event";
import WebsiteLayout from './layouts/WebsiteLayout/WebsiteLayout';
import About from './pages/About/About';
import TicketsTerms from './pages/Ticket-T&C/TicketTandC';
import EventTerms from './pages/Event-T&C/EventTandC';
import Ticket from './pages/Ticket/Ticket';
import JoinUs from './pages/JoinUs/JoinsUs';


const App = () => {
  return (
    <BrowserRouter>
      <Routes>

        <Route path="/" element={<WebsiteLayout />}>

          <Route path="/" element={<Home />} />

          {/* <Route path="/event" element={<Event />} />

          <Route path="/ticket" element={<Ticket />} /> */}

          <Route path="/about-us" element={<About />} />

          <Route path="/joinus" element={<JoinUs />} />

          <Route path="/event-t&c" element={<EventTerms />} />

          <Route path="/ticket-t&c" element={<TicketsTerms />} />

        </Route>

      </Routes>
    </BrowserRouter>
  );
};

export default App;